import { LitElement, html, css } from 'lit';
import { sharedStyles } from './base.js';

// <gt-page-shell> — consistent page gutter + max width + vertical rhythm.
//   size: default (1240px) | wide (1600px) | narrow (860px)
export class GtPageShell extends LitElement {
  static properties = { size: { type: String } };
  static styles = [
    sharedStyles,
    css`
      :host {
        display: block;
      }
      .shell {
        max-width: 1240px;
        margin: 0 auto;
        padding: var(--space-7, 32px) clamp(var(--space-4, 16px), 3vw, var(--space-8, 48px))
          var(--space-8, 48px);
      }
      :host([size='wide']) .shell {
        max-width: 1600px;
      }
      :host([size='narrow']) .shell {
        max-width: 860px;
      }
      ::slotted(*) {
        margin-top: var(--space-6, 24px);
      }
      ::slotted(:first-child) {
        margin-top: 0;
      }
    `,
  ];
  render() {
    return html`<div class="shell"><slot></slot></div>`;
  }
}
customElements.define('gt-page-shell', GtPageShell);
